var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromtAddPeopleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 2,
    fill: "#DB0011"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 14.926C17.9107 14.926 19.4612 13.3756 19.4612 11.463C19.4612 9.55045 17.9107 8 15.9982 8C14.0856 8 12.5352 9.55045 12.5352 11.463C12.5352 13.3756 14.0856 14.926 15.9982 14.926Z",
    stroke: "white",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9986 16.2383C12.6606 16.2383 9.94727 17.8716 9.94727 19.8441V21.6738H22.0589V19.8441C22.0589 17.8716 19.3188 16.2383 16.0076 16.2383H15.9986Z",
    stroke: "white",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93359 13.793V17.6925",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.75H9.92184",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromtAddPeopleLogo);
export default __webpack_public_path__ + "static/media/promtAddPeopleLogo.ff745067236c4c90478c70e978d58e48.svg";
export { ForwardRef as ReactComponent };